import { Container, Graphics } from "pixi.js";
import { indoor } from "./common.js";

/** Edificio STEM: investigación y posgrados. El más nuevo, y se nota en el vidrio. */
export function stem(): Container {
  const scene = indoor({ wall: 0xf2f5f8, floor: 0xdfe4e8, skirting: 0xa8b4bf });

  // Muro cortina: una sola pared de vidrio en vez de ventanas sueltas.
  const curtain = new Graphics();
  curtain.rect(0, 20, 960, 200).fill({ color: 0xa8d8ee, alpha: 0.7 });
  for (let i = 0; i <= 10; i++) {
    curtain
      .moveTo(i * 96, 20)
      .lineTo(i * 96, 220)
      .stroke({ width: 5, color: 0xf4f7fa });
  }
  curtain.moveTo(0, 120).lineTo(960, 120).stroke({ width: 5, color: 0xf4f7fa });
  scene.addChild(curtain);

  // Escalera abierta al fondo: el gesto que tienen todos los edificios de posgrado.
  const stairs = new Graphics();
  for (let i = 0; i < 6; i++) {
    stairs.rect(640 + i * 30, 150 + i * 14, 34, 14).fill({ color: 0xc9d8e2, alpha: 0.9 });
  }
  scene.addChild(stairs);

  return scene;
}
